import { Routes } from '@angular/router';
// Importación de componentes
import { LoginComponent } from './auth/login/login.component';
import { GoogleLoginComponent } from './auth/google-login/google-login.component';
import { GoogleLoginBorisComponent } from './auth/google-login-boris/google-login-boris.component';
import { HomeComponent} from './components/home/home.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { GeneralInterfaceComponent } from './components/general-interface/general-interface.component';
import { MainComponent } from './components/main/main.component';
import { GetAddonsComponent } from './components/get-addons/get-addons/get-addons.component';
import { GetUseRoleComponent } from './components/get-UseRole/get-use-role/get-use-role.component';
import { UnblockUserComponent } from './components/unblock-user/unblock-user/unblock-user.component';
import { UpdateContactComponent } from './components/updatecontact/updatecontact/updatecontact.component';
import { SuppressedEmailComponentsComponent } from './components/suppressed-email-components/suppressed-email-components.component';
import { CrcConsultComponentsComponent } from './components/crc-consult-components/crc-consult-components.component';
import { CreateUserComponent } from './components/create-user/create-user.component';
import { GetOtpComponent } from './components/get-otp/get-otp.component';
import { FirstLoginComponent } from './components/first-login/first-login.component';
import { CertificadosComponent } from './components/certificados/certificados.component';
import { InfraestructuraSeguimientoComponent } from './components/infraestructura-seguimiento/infraestructura-seguimiento.component';
import { ChatBorisComponent } from './components/chat-boris/chat-boris.component';
import { InventarioComponent } from './components/inventario/inventario.component';
import { VinculadorPagadorPmComponent } from './components/vinculador-pagador-pm/vinculador-pagador-pm.component';
// Importación de guards
import { AuthGuard } from './guards/auth.guard';
import { RolGuard } from './guards/rol.guard';
import { PasswordGuard } from './guards/password.guard';
import { AdminGuard } from './guards/admin.guard';

// Definición de rutas hijas (pages)
const childRoutes: Routes = [
  { path: '', component: MainComponent },
  { path: 'get-addons', component: GetAddonsComponent },
  { path: 'get-user', component: GetUseRoleComponent },
  { path: 'unblock-user', component: UnblockUserComponent },
  { path: 'update-contact', component: UpdateContactComponent },
  { path: 'crc-consult', component: CrcConsultComponentsComponent },
  { path: 'suppressed-email', component: SuppressedEmailComponentsComponent },
  { path: 'create-user', component: CreateUserComponent },
  { path: 'get-otp', component: GetOtpComponent },
  { path: 'first-login', component: FirstLoginComponent },
  { path: 'certificados', component: CertificadosComponent },
  { path: 'infraestructura-seguimiento', component: InfraestructuraSeguimientoComponent},
  { path: 'chat-boris', component: ChatBorisComponent },
  { path: 'inventario', component: InventarioComponent },
  { path: 'vinculador-pagador-pm', component: VinculadorPagadorPmComponent }
];

const childRoutesPassword: Routes=[
  
]

// Rutas principales
export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' }, // Redirección por defecto
  { path: 'login-google', component: GoogleLoginComponent },
  { path: 'login-google-boris', component: GoogleLoginBorisComponent },
  { path: 'home', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { 
    path: 'password', 
    component: ResetPasswordComponent ,
    canActivate:[PasswordGuard] },
  {
    path: 'pages',
    component: GeneralInterfaceComponent,
    canActivateChild: [AuthGuard, RolGuard], // Aplica guards a todas las rutas hijas
    children: [
      ...childRoutes, // Reutiliza las rutas hijas definidas en la constante
      { path: '**', redirectTo: '', pathMatch: 'full' } // Redirección wildcard
    ]
  },

  { path: '**', redirectTo: '/home', pathMatch: 'full' } // Redirección global
];
